import Slider from '@ui/Slider/component'

export default function (element: HTMLElement | string, config = {}): void {
  let el: HTMLElement | null

  if (typeof element === 'string') {
    el = document.querySelector<HTMLElement>(element)
  } else {
    el = element
  }

  if (!el) {
    return
  }

  const defaultConfig: { slidesPerView: 'auto'; spaceBetween: number } = {
    slidesPerView: 'auto',
    spaceBetween: 24,
  }

  Slider(el, Object.assign({}, defaultConfig, config))
}
